import DataTable from "./BaseDataTable";
import { withSorting } from "./WithSorting";

export default withSorting()(DataTable);
